import useRequest from '@/websdk/utils/request';
import { useEffect, useState } from 'react';
import { data_ids } from '@/constant/data_ids';
import { ml } from '@/utils/translate_lngs';
import { calcUpperAndLower } from '@/utils/common';

export default (function (param) {
  const [temperature, setTemperature] = useState({});
  const { data, exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'GET_PRODUCE_PROCESS_ANALYSIS_QUALITY',
    method: 'GET',
  });

  useEffect(() => {
    if (param && JSON.stringify(param) !== '{}') {
      let url = `/api/produce/process/analysis/temperature`;
      Object.keys(param).forEach((key, index) => {
        if (index === 0) {
          url += `?${key}=${param[key]}`;
        } else {
          url += `&${key}=${param[key]}`;
        }
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  //转成list和series数据
  const object2ListSeries = obj => {
    let list = [];
    let categories_ = [];
    let series_ = {};
    let fields = [];
    let columns_ = [];
    let numbers = {};
    let catch_time_ = [];
    Object.keys(obj).forEach(shotCount => {
      let obj_ = { shot_count: shotCount };
      categories_.push(parseInt(shotCount));
      Object.keys(obj[shotCount]).forEach(id => {
        if (id === 'catch_time') {
          obj_.catch_time = obj[shotCount][id];
          catch_time_.push(obj[shotCount][id]);
        } else {
          if (fields.indexOf(data_ids[id]) === -1) {
            fields.push(data_ids[id]);
          }
          obj_[data_ids[id]] = obj[shotCount][id] ? parseFloat(obj[shotCount][id]) : 0;
          let temp = data_ids[id].replace(/ACTUAL_TEMP|SET_TEMP/g, '');
          //实际温度
          if (data_ids[id].indexOf('ACTUAL_TEMP') !== -1) {
            if (!numbers[temp]) {
              numbers[temp] = [];
            }
            numbers[temp].push(obj[shotCount][id] ? parseFloat(obj[shotCount][id]) : 0);
          }

          if (series_[temp] && series_[temp][data_ids[id]]) {
            series_[temp][data_ids[id]].push(
              obj[shotCount][id] ? parseFloat(obj[shotCount][id]) : 0
            );
          } else {
            if (!series_[temp]) {
              series_[temp] = {};
            }
            series_[temp][data_ids[id]] = [obj[shotCount][id] ? parseFloat(obj[shotCount][id]) : 0];
          }
        }
      });
      list.push(obj_);
    });
    fields.forEach(field => {
      columns_.push({
        field: field,
        title: `${ml(field.replace(/\d/g, ''))}${field.replace(/ACTUAL_TEMP|SET_TEMP/g, '')}`,
        halign: 'center',
        align: 'right',
        width: 100,
      });
    });

    Object.keys(numbers).forEach(temp => {
      if (series_[temp]) {
        let calcData = calcUpperAndLower(numbers[temp]);
        series_[temp] = { ...series_[temp], ...calcData };
      }
    });
    return {
      dataList: list.sort((a, b) => {
        return a.shotCount > b.shotCount ? -1 : 1;
      }),
      categories: categories_,
      series: series_,
      columns: columns_,
      catch_time: catch_time_,
    };
  };

  useEffect(() => {
    if (data && JSON.stringify(data) !== '{}') {
      let new_data = object2ListSeries(data);
      setTemperature(new_data);
    }
  }, [data]);

  return [temperature, isRequestSuccessed];
});
